
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import UsuarioService from "@/service/v1/seguranca/UsuarioService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Pdf from "./_Pdf.vue";
import RelatorioPagamentoInstrutorIndex from "./_IndexInstrutor.vue";

@Options({
    name: "RelatorioPagamentoIndex",
    components: { CardRh, KDataTable, Pdf, RelatorioPagamentoInstrutorIndex },
})
export default class RelatorioPagamentoIndex extends IndexModelTable {
    public cpf: any = null;
    public cpfFiltro = '';
    public disciplinaIdFiltro = '';
    public data_min: any = null;
    public data_max: any = null;
    public modal_visualizar_instrutor = 'modal_visualizar_instrutor_relatorio';

    public meses = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    public dias = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get hasPermissaoAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
    }

    public gerarRelatorioExcell() {
        window.open(this.service.getApiUrl() + `/Relatorio/Pagamento/Excel?dataAulaMin=${this.data_min}&dataAulaMax=${this.data_max}&token=${this.token}`);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get hj() {
        return new Date().getFullYear() + '-' + this.meses[new Date().getMonth()] + '-' + this.dias[new Date().getDate()];
    }

    get last15days() {
        const dataReferencia = new Date();
        dataReferencia.setDate(dataReferencia.getDate() - 5);
        return dataReferencia.getFullYear() + '-' + this.meses[dataReferencia.getMonth()] + '-' + this.dias[dataReferencia.getDate()];
    }

    public limparFiltros() {
        this.data_min = this.last15days;
        this.data_max = this.hj;
        this.cpfFiltro = '';
        this.disciplinaIdFiltro = '';
        this.refreshTable();
    }

    public aplicarUltimosDias(dias) {
        const dataFinal = new Date();
        const dataInicial = new Date();
        dataInicial.setDate(dataFinal.getDate() - (dias - 1));

        this.data_min = this.formatarDataInput(dataInicial);
        this.data_max = this.formatarDataInput(dataFinal);
        this.refreshTable();
    }

    public aplicarMesAtual() {
        const hoje = new Date();
        const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

        this.data_min = this.formatarDataInput(primeiroDia);
        this.data_max = this.formatarDataInput(hoje);
        this.refreshTable();
    }

    public aplicarMesAnterior() {
        const hoje = new Date();
        const primeiroDiaMesAnterior = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
        const ultimoDiaMesAnterior = new Date(hoje.getFullYear(), hoje.getMonth(), 0);

        this.data_min = this.formatarDataInput(primeiroDiaMesAnterior);
        this.data_max = this.formatarDataInput(ultimoDiaMesAnterior);
        this.refreshTable();
    }

    public formatarDataInput(dataReferencia) {
        const ano = dataReferencia.getFullYear();
        const mes = String(dataReferencia.getMonth() + 1).padStart(2, '0');
        const dia = String(dataReferencia.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
    }

    created() {
        this.data_min = this.last15days;
        this.data_max = this.hj;
        this.service = new UsuarioService();
        this.config.ajax = {
            url: this.service.getApiUrl() + '/Relatorio/Pagamento',
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    dataAulaMin: this.data_min,
                    dataAulaMax: this.data_max,
                    cpf: this.cpfFiltro,
                    disciplinaId: this.disciplinaIdFiltro,
                    search: d.search.value,
                };
                return dados;
            }
        };
        this.config.columns = [
            { data: 'id', name: 'id', searchable: false },
            { data: 'numeroFuncional', name: 'numerofuncional', searchable: false },
            { data: 'cargo', name: 'cargo', searchable: false },
            { data: 'nome', name: 'nome', searchable: false },
            { data: 'titulacao', name: 'titulacao', searchable: false },
            { data: 'interno', name: 'interno', searchable: false },
            { data: 'externo', name: 'externo', searchable: false },
            { data: 'total', name: 'total', searchable: false },
        ];
        this.config.columnDefs = [
            {
                targets: 2,
                render: (row) => {
                    return row ?? 'Professor';
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return row.replaceAll('_', ' ');
                }
            },
            {
                targets: 5,
                render: (row, type, val) => {
                    return val['aulasInternoOk'] ? '<button class="btn btn-pmes-primary btn-sm">' + row + '</button>' : '<button class="btn btn-pmes-danger btn-sm">' + row + '</button>';
                }
            },
            {
                targets: 6,
                render: (row, type, val) => {
                    return val['aulasExternoOk'] ? '<button class="btn btn-pmes-primary btn-sm">' + row + '</button>' : '<button class="btn btn-pmes-danger btn-sm">' + row + '</button>';
                }
            },
            {
                targets: 7,
                render: (row) => {
                    return 'R$ ' + row.toFixed(2);
                }
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 8,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' + this.modal_visualizar_instrutor + '" title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $('[btn-show]').click((btn) => {
            this.cpf = null;
            setTimeout(() => {
                this.cpf = $(btn.currentTarget).data().id;
            }, 10);
        });
    }
}
